// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios2 from 'utils/axios2';
import { dispatch } from '../index';

// ----------------------------------------------------------------------
// const apiHost = 'https://youteach.ai/api'
const apiHost = process.env.REACT_APP_API_URL;
// console.log(apiHost)

const initialState = {
    error: null,
    vectors: [],
    apikeys: []
};

const slice = createSlice({
    name: 'vector',
    initialState,
    reducers: {
        getVector(state, action) {
            state.vectors = action.payload;
        },
        getApiKeys(state, action) {
            state.apikeys = action.payload;
        },
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        }
    }
    // extraReducers(builder) {
    //     builder
    //         .addCase(fetchAnswer.pending, (state) => {
    //             state.status = 'loading';
    //         })
    //         .addCase(fetchAnswer.rejected, (state, action) => {
    //             state.status = 'failed';
    //             state.queries[state.queries.length - 1].error =
    //                 'Something went wrong. Please try again later.';
    //         });
    // },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function fetchVectors(project_name) {
    return async () => {
        try {
            const name = (project_name || '').replaceAll('/', '');
            if (!name) {
                dispatch(slice.actions.getVector([]));
                return;
            }
            const response = await axios2.get('/research-docs/list', {
                params: { project_name: name }
            });
            const list = Array.isArray(response.data) ? response.data : [];
            dispatch(slice.actions.getVector(list));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.getVector([]));
        }
    };
}

export function fetchApiKeys(project_name) {
    return async () => {
        try {
            const user_token = localStorage.getItem('user_token');
            const response = await axios2.get(`/api/apikeys?user_token=${user_token}&project_name=${project_name}`);
            dispatch(slice.actions.getApiKeys(response.data));
            // return response.data;
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function updateModel(project_name, vector_id, storage, model, temperature, top_k_docs) {
    return async () => {
        try {
            const formData = new FormData();
            const user_token = localStorage.getItem('user_token');
            formData.append('user_token', user_token);
            formData.append('project_name', project_name);
            formData.append('vector_id', vector_id);
            formData.append('storage', storage);
            formData.append('model', model);
            formData.append('temperature', temperature);
            formData.append('top_k_docs', top_k_docs);

            const response = await axios2.post('/api/models/update', formData);
            return response.data;
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            throw error;
        }
    };
}
